// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AnbefaltBilpleieBilvaskDrammenRouteImport } from './routes/anbefalt-bilpleie-bilvask-drammen'
import { Route as AvmeldRouteImport } from './routes/avmeld'
import { Route as BestBilpleieBilvaskDrammenRouteImport } from './routes/best-bilpleie-bilvask-drammen'
import { Route as BestilleBilpleieBilvaskDrammenRouteImport } from './routes/bestille-bilpleie-bilvask-drammen'
import { Route as BilpleieDrammenRouteImport } from './routes/bilpleie-drammen'
import { Route as BilvaskDrammenRouteImport } from './routes/bilvask-drammen'
import { Route as BilvaskKonnerudRouteImport } from './routes/bilvask-konnerud'
import { Route as BilvaskLierRouteImport } from './routes/bilvask-lier'
import { Route as BilvaskMjondalenRouteImport } from './routes/bilvask-mjondalen'
import { Route as BookRouteImport } from './routes/book'
import { Route as DekkskiftDrammenRouteImport } from './routes/dekkskift-drammen'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as FelgrensDrammenRouteImport } from './routes/felgrens-drammen'
import { Route as GullKomplettDrammenRouteImport } from './routes/gull-komplett-drammen'
import { Route as InnvendigVaskDrammenRouteImport } from './routes/innvendig-vask-drammen'
import { Route as KomplettVaskDrammenRouteImport } from './routes/komplett-vask-drammen'
import { Route as MotorromrensDrammenRouteImport } from './routes/motorromrens-drammen'
import { Route as OljeskiftDrammenRouteImport } from './routes/oljeskift-drammen'
import { Route as PersonvernRouteImport } from './routes/personvern'
import { Route as PoleringAvBilDrammenRouteImport } from './routes/polering-av-bil-drammen'
import { Route as PoleringDrammenRouteImport } from './routes/polering-drammen'
import { Route as PremiumpakkeDrammenRouteImport } from './routes/premiumpakke-drammen'
import { Route as PriserRouteImport } from './routes/priser'
import { Route as RustfjerningDrammenRouteImport } from './routes/rustfjerning-drammen'
import { Route as SkifteDekkDrammenRouteImport } from './routes/skifte-dekk-drammen'
import { Route as UtvendigVaskDrammenRouteImport } from './routes/utvendig-vask-drammen'
import { Route as AKodeRouteImport } from './routes/a.$kode'
import { Route as BloggIndexRouteImport } from './routes/blogg.index'
import { Route as BloggSlugRouteImport } from './routes/blogg.$slug'
import { Route as TjenesterSlugRouteImport } from './routes/tjenester.$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AnbefaltBilpleieBilvaskDrammenRoute = AnbefaltBilpleieBilvaskDrammenRouteImport.update({
            id: '/anbefalt-bilpleie-bilvask-drammen',path: '/anbefalt-bilpleie-bilvask-drammen',getParentRoute: () => rootRouteImport
          })
const AvmeldRoute = AvmeldRouteImport.update({
            id: '/avmeld',path: '/avmeld',getParentRoute: () => rootRouteImport
          })
const BestBilpleieBilvaskDrammenRoute = BestBilpleieBilvaskDrammenRouteImport.update({
            id: '/best-bilpleie-bilvask-drammen',path: '/best-bilpleie-bilvask-drammen',getParentRoute: () => rootRouteImport
          })
const BestilleBilpleieBilvaskDrammenRoute = BestilleBilpleieBilvaskDrammenRouteImport.update({
            id: '/bestille-bilpleie-bilvask-drammen',path: '/bestille-bilpleie-bilvask-drammen',getParentRoute: () => rootRouteImport
          })
const BilpleieDrammenRoute = BilpleieDrammenRouteImport.update({
            id: '/bilpleie-drammen',path: '/bilpleie-drammen',getParentRoute: () => rootRouteImport
          })
const BilvaskDrammenRoute = BilvaskDrammenRouteImport.update({
            id: '/bilvask-drammen',path: '/bilvask-drammen',getParentRoute: () => rootRouteImport
          })
const BilvaskKonnerudRoute = BilvaskKonnerudRouteImport.update({
            id: '/bilvask-konnerud',path: '/bilvask-konnerud',getParentRoute: () => rootRouteImport
          })
const BilvaskLierRoute = BilvaskLierRouteImport.update({
            id: '/bilvask-lier',path: '/bilvask-lier',getParentRoute: () => rootRouteImport
          })
const BilvaskMjondalenRoute = BilvaskMjondalenRouteImport.update({
            id: '/bilvask-mjondalen',path: '/bilvask-mjondalen',getParentRoute: () => rootRouteImport
          })
const BookRoute = BookRouteImport.update({
            id: '/book',path: '/book',getParentRoute: () => rootRouteImport
          })
const DekkskiftDrammenRoute = DekkskiftDrammenRouteImport.update({
            id: '/dekkskift-drammen',path: '/dekkskift-drammen',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const FelgrensDrammenRoute = FelgrensDrammenRouteImport.update({
            id: '/felgrens-drammen',path: '/felgrens-drammen',getParentRoute: () => rootRouteImport
          })
const GullKomplettDrammenRoute = GullKomplettDrammenRouteImport.update({
            id: '/gull-komplett-drammen',path: '/gull-komplett-drammen',getParentRoute: () => rootRouteImport
          })
const InnvendigVaskDrammenRoute = InnvendigVaskDrammenRouteImport.update({
            id: '/innvendig-vask-drammen',path: '/innvendig-vask-drammen',getParentRoute: () => rootRouteImport
          })
const KomplettVaskDrammenRoute = KomplettVaskDrammenRouteImport.update({
            id: '/komplett-vask-drammen',path: '/komplett-vask-drammen',getParentRoute: () => rootRouteImport
          })
const MotorromrensDrammenRoute = MotorromrensDrammenRouteImport.update({
            id: '/motorromrens-drammen',path: '/motorromrens-drammen',getParentRoute: () => rootRouteImport
          })
const OljeskiftDrammenRoute = OljeskiftDrammenRouteImport.update({
            id: '/oljeskift-drammen',path: '/oljeskift-drammen',getParentRoute: () => rootRouteImport
          })
const PersonvernRoute = PersonvernRouteImport.update({
            id: '/personvern',path: '/personvern',getParentRoute: () => rootRouteImport
          })
const PoleringAvBilDrammenRoute = PoleringAvBilDrammenRouteImport.update({
            id: '/polering-av-bil-drammen',path: '/polering-av-bil-drammen',getParentRoute: () => rootRouteImport
          })
const PoleringDrammenRoute = PoleringDrammenRouteImport.update({
            id: '/polering-drammen',path: '/polering-drammen',getParentRoute: () => rootRouteImport
          })
const PremiumpakkeDrammenRoute = PremiumpakkeDrammenRouteImport.update({
            id: '/premiumpakke-drammen',path: '/premiumpakke-drammen',getParentRoute: () => rootRouteImport
          })
const PriserRoute = PriserRouteImport.update({
            id: '/priser',path: '/priser',getParentRoute: () => rootRouteImport
          })
const RustfjerningDrammenRoute = RustfjerningDrammenRouteImport.update({
            id: '/rustfjerning-drammen',path: '/rustfjerning-drammen',getParentRoute: () => rootRouteImport
          })
const SkifteDekkDrammenRoute = SkifteDekkDrammenRouteImport.update({
            id: '/skifte-dekk-drammen',path: '/skifte-dekk-drammen',getParentRoute: () => rootRouteImport
          })
const UtvendigVaskDrammenRoute = UtvendigVaskDrammenRouteImport.update({
            id: '/utvendig-vask-drammen',path: '/utvendig-vask-drammen',getParentRoute: () => rootRouteImport
          })
const AKodeRoute = AKodeRouteImport.update({
            id: '/a/$kode',path: '/a/$kode',getParentRoute: () => rootRouteImport
          })
const BloggIndexRoute = BloggIndexRouteImport.update({
            id: '/blogg/',path: '/blogg/',getParentRoute: () => rootRouteImport
          })
const BloggSlugRoute = BloggSlugRouteImport.update({
            id: '/blogg/$slug',path: '/blogg/$slug',getParentRoute: () => rootRouteImport
          })
const TjenesterSlugRoute = TjenesterSlugRouteImport.update({
            id: '/tjenester/$slug',path: '/tjenester/$slug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AnbefaltBilpleieBilvaskDrammenRoute: AnbefaltBilpleieBilvaskDrammenRoute,AvmeldRoute: AvmeldRoute,BestBilpleieBilvaskDrammenRoute: BestBilpleieBilvaskDrammenRoute,BestilleBilpleieBilvaskDrammenRoute: BestilleBilpleieBilvaskDrammenRoute,BilpleieDrammenRoute: BilpleieDrammenRoute,BilvaskDrammenRoute: BilvaskDrammenRoute,BilvaskKonnerudRoute: BilvaskKonnerudRoute,BilvaskLierRoute: BilvaskLierRoute,BilvaskMjondalenRoute: BilvaskMjondalenRoute,BookRoute: BookRoute,DekkskiftDrammenRoute: DekkskiftDrammenRoute,FaqRoute: FaqRoute,FelgrensDrammenRoute: FelgrensDrammenRoute,GullKomplettDrammenRoute: GullKomplettDrammenRoute,InnvendigVaskDrammenRoute: InnvendigVaskDrammenRoute,KomplettVaskDrammenRoute: KomplettVaskDrammenRoute,MotorromrensDrammenRoute: MotorromrensDrammenRoute,OljeskiftDrammenRoute: OljeskiftDrammenRoute,PersonvernRoute: PersonvernRoute,PoleringAvBilDrammenRoute: PoleringAvBilDrammenRoute,PoleringDrammenRoute: PoleringDrammenRoute,PremiumpakkeDrammenRoute: PremiumpakkeDrammenRoute,PriserRoute: PriserRoute,RustfjerningDrammenRoute: RustfjerningDrammenRoute,SkifteDekkDrammenRoute: SkifteDekkDrammenRoute,UtvendigVaskDrammenRoute: UtvendigVaskDrammenRoute,AKodeRoute: AKodeRoute,BloggSlugRoute: BloggSlugRoute,TjenesterSlugRoute: TjenesterSlugRoute,BloggIndexRoute: BloggIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)